<!--
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-23 09:28:11
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2024-12-23 10:06:18
 * @FilePath: src/components/workbench-design/grid-layout/dynamic/index.vue
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 -->
<!--
  @Author 22030124/xieyq
  @Date 2023-11-21 18:53:35
  @Description npm动态加载组件
-->
<template>
  <div :class="[scope.clsPrefix, fieldData.customClass]" v-loading="loading">
    <!-- 动态组件 -->
    <component
      ref="component"
      :is="asyncComponent"
      :class="`${scope.clsPrefix}_body`"
      :data="componentData"
      @auth-fail="onAuthFail"
      @smart-analysis="onSmartAnalysis"
    />
    <!-- 组件加载失败 -->
    <span v-if="!loading && !asyncComponent" :class="`${scope.clsPrefix}_tips`">
      {{ fieldData.name }} -- 未知卡片
    </span>
  </div>
</template>

<script>
// 加载组件
import loadComponent from './loadComponent.js'
// 事件总线：将卡片内部事件（如智能分析）透传到工作台顶层
import eventBus from '../../utils/eventBus'
// 配置文件
// import config from '@/config'
// const env = process.env.VUE_APP_ENV
// 是否生产环境
// const IS_PRODUCTION = env === 'production'
import { mapGetters, mapState } from 'vuex'
import { getToken } from '@/utils/auth'
import asyncComputed from 'vue-async-computed'
import Vue from 'vue'
Vue.use(asyncComputed)
export default {
  // 组件名称
  name: 'LCPPkgNpmDynamicWidget',
  mixins: [loadComponent],
  props: {
    // 组件对象
    element: Object
  },
  // 数据
  data() {
    return {
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'lcp-pkg-npm-dynamic-widget'
      },
      // 异步组件
      asyncComponent: null,
      // 是否加载
      loading: true
    }
  },
  asyncComputed: {
    // 组件数据
    async componentData() {
      let admin = false
      if (this.fieldData.appId) {
        const appData = this.$store.state.user.appList.find(
          (item) => item.id == this.fieldData.appId
        )
        if (appData.ownerUserCode == this.userInfo.userCode) {
          admin = true
        }
      }
      return {
        // dev开发测试环境 prod生产环境
        // env: IS_PRODUCTION ? 'prod' : 'dev',
        // 取cookie中的key
        tokenKey: this.$store.state.user.sysConfig.accessTokenCookieName,
        token: getToken(),
        // 组件id
        // 待接入到工作台之后，由工作台传入，组件列表中的组件id字段是id
        blockId: this.fieldData.blockId || this.fieldData.id,
        // 固定值
        client: 'EIIP',
        isEip: true,
        // 用户工号
        userCode: this.userInfo?.userCode,
        admin
      }
    }
  },
  watch: {
    componentData: {
      handler(newVal) {
        if (newVal !== null) {
          // componentData 已更新，可以安全使用
          this.init()
        }
      },
      immediate: true
    }
  },
  computed: {
    // 当前用户信息
    ...mapGetters(['userInfo']),
    ...mapState('user', ['appList']),
    // 组件参数
    fieldData() {
      return this.element?.data || {}
    }
  },
  // 创建完成
  created() {
    // 初始化方法
    // this.init()
  },
  // 挂载完成
  mounted() {},
  // 方法
  methods: {
    /**
     * 初始化按钮
     * @returns {void}
     */
    async init() {
      try {
        // 加载组件
        await this.loadComponent()
      } catch (err) {
        console.log('加载失败', err)
      }
    },

    /**
     * 加载组件（分流到本地 registry 或远程 hel-micro）
     */
    async loadComponent() {
      console.log('this.componentData', this.componentData)
      console.log('this.element.data', this.element.data)
      try {
        // 走 mixin 里的统一入口 loadCardComponent，本地/远程自动分流
        this.asyncComponent = await this.loadCardComponent(this.element.data)
        console.log('this.asyncComponent', this.asyncComponent)
        this.loading = false
      } catch (err) {
        this.loading = false
        console.log('组件加载失败', err)
      }
    },

    /**
     * 处理权限校验失败
     * @returns {void}
     */
    onAuthFail() {
      // 认证失败
      console.log(this.fieldData?.name, '认证失败')
      return
      // 删除对应的token
      /* this.$store.dispatch('user/resetToken').then(() => {
        // 重新刷新页面
        window.location.reload()
      }) */
    },

    /**
     * 卡片智能分析事件：通过 eventBus 透传到工作台顶层（smart-engine-new/index.vue）
     * unified 驾驶舱的卡片经 workbench-design 多层动态渲染，无法直接 $emit 到路由父级，
     * 因此改用 eventBus 统一转发。
     * @param {*} payload 卡片 emit 的智能分析参数
     */
    onSmartAnalysis(payload) {
      eventBus.$emit('smart-analysis', payload)
    }
  }
}
</script>

<style lang="scss">
// 组件样式
$class-prefix: 'lcp-pkg-npm-dynamic-widget';
.#{$class-prefix} {
  position: relative;
  height: 100%;
  overflow: hidden;

  // 主体内容
  &_body {
    height: 100%;
    border-radius: 4px;
    overflow: hidden;
  }

  // 提示
  &_tips {
    display: block;
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
    overflow: hidden;
  }
}
</style>
